import * as yup from 'yup';

export const validationSchema = yup.object({
	testingInformation: yup.string().required('Testing Information is required'),
	communicationPhoneNumber: yup.string().required('Phone Number is required'),
	communicationEmail: yup.string().email('Invalid email').required('Email is required'),
});
